"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es6.function.name");

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartDonutOptions = _interopRequireDefault(require("./mw-chart-donut-options"));

var _mwChartDonutClickOptions = _interopRequireDefault(require("./mw-chart-donut-click-options"));

var _mwChartDonutLabelFormatterOptions = _interopRequireDefault(require("./mw-chart-donut-label-formatter-options"));

var _mwChartDonutLegendClickOptions = _interopRequireDefault(require("./mw-chart-donut-legend-click-options"));

var _mwChartDonutTooltipOptions = _interopRequireDefault(require("./mw-chart-donut-tooltip-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

var _styles = require("../styles");

function donutChartData(series) {
  var selectedSeries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var data = [];

  if (typeof series.data !== 'undefined') {
    data = series.data.map(function (seriesData, index) {
      var selected = selectedSeries.some(function (sliceIndex) {
        return sliceIndex === index;
      });
      return {
        name: seriesData.key,
        y: seriesData.value,
        // eslint-disable-line id-length
        sliced: selected,
        selected: selected
      };
    });
  }

  return [{
    name: series.name,
    type: 'pie',
    data: data
  }];
}

function fillSeriesColors(seriesColors, seriesSize) {
  var overflow = seriesSize - seriesColors.length;
  var colorArrSize = _styles.DEFAULT_SERIES_CHART_COLORS.length - 1;
  var defaultColorIndex = 0;

  while (overflow > 0) {
    seriesColors.push(_styles.DEFAULT_SERIES_CHART_COLORS[defaultColorIndex]);

    if (defaultColorIndex === colorArrSize) {
      defaultColorIndex = 0;
    } else {
      defaultColorIndex++;
    }

    overflow--;
  }

  return seriesColors;
}
/**
 * A class for rendering a donut chart
 */


var MwChartDonut =
/*#__PURE__*/
function () {
  /**
   * Create a new Donut Chart
   * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
   */
  function MwChartDonut(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartDonut);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {SeriesData} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartDonut, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      if (!chartData) {
        this.__chartData = {};
      } else {
        this.__chartData = (0, _coerce.default)(chartData, _seriesData.default, "chartData should be shaped like a SeriesData. Provided value: ".concat(JSON.stringify(chartData)));
      }
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartDonutChartOptions} chartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(chartOptions) {
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartDonutOptions.default, "chartOptions must be a valid MwChartDonutChartOptions object. Provided value: ".concat(JSON.stringify(chartOptions)));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      try {
        this.error = false;

        if (!this.__renderTarget) {
          throw new Error('renderTarget not set. Unable to render visualization');
        }

        var safeHighchartOptions = this.__chartOptions;
        var donutData = donutChartData(this.__chartData, safeHighchartOptions.selectedIndexPoints);
        var series = donutData[0];
        var seriesColors = safeHighchartOptions.seriesColors;

        if (seriesColors !== _styles.DEFAULT_SERIES_CHART_COLORS && seriesColors.length < series.data.length) {
          seriesColors = fillSeriesColors(seriesColors, series.data.length);
        }

        var safeDataLabelFormatter = function safeDataLabelFormatter() {
          var options = new _mwChartDonutLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            key: this.key,
            percentage: this.percentage,
            value: this.y
            /* eslint-enable no-invalid-this */

          });
          return safeHighchartOptions.dataLabelFormatter(options);
        };

        var onLegendClickCallback;

        if (safeHighchartOptions.onLegendClick) {
          onLegendClickCallback = function onLegendClickCallback(clickEvent) {
            clickEvent.preventDefault();
            var options = new _mwChartDonutLegendClickOptions.default({
              seriesName: this.name // eslint-disable-line no-invalid-this

            });
            return safeHighchartOptions.onLegendClick(options);
          };
        } else {
          onLegendClickCallback = function onLegendClickCallback(event) {
            return event.preventDefault();
          };
        }

        var onPointClickCallback;

        if (safeHighchartOptions.onPointClick) {
          onPointClickCallback = function onPointClickCallback(event) {
            var options = new _mwChartDonutClickOptions.default(event);
            return safeHighchartOptions.onPointClick(options);
          };
        }

        var safeTooltipFormatter;

        if (safeHighchartOptions.tooltipFormatter) {
          safeTooltipFormatter = function safeTooltipFormatter() {
            /* eslint-disable no-invalid-this */
            var options = new _mwChartDonutTooltipOptions.default({
              point: this.point,
              series: this.series
            });
            /* eslint-enable no-invalid-this */

            return safeHighchartOptions.tooltipFormatter(options);
          };
        }

        _highcharts.default.chart(this.__renderTarget, {
          title: {
            text: ''
          },
          chart: {
            renderTo: this.__renderTarget,
            reflow: false,
            style: {
              fontFamily: _styles.FONT_FAMILY,
              color: _styles.AXIS_LABEL_FONT_COLOR
            }
          },
          credits: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          legend: {
            itemStyle: {
              fontWeight: _styles.LEGEND_LABEL_FONT_WEIGHT
            }
          },
          tooltip: {
            style: {
              fontFamily: _styles.FONT_FAMILY
            },
            useHTML: true,
            formatter: safeTooltipFormatter
          },
          plotOptions: {
            pie: {
              animation: safeHighchartOptions.animate,
              innerSize: '40%',
              dataLabels: {
                enabled: safeHighchartOptions.areDataLabelsVisible,
                style: {
                  fontFamily: _styles.FONT_FAMILY,
                  color: _styles.DEFAULT_DATALABEL_COLOR,
                  fontWeight: 'normal'
                },
                formatter: safeDataLabelFormatter
              },
              point: {
                events: {
                  legendItemClick: onLegendClickCallback
                }
              },
              events: {
                click: onPointClickCallback
              },
              colors: seriesColors,
              showInLegend: safeHighchartOptions.showLegend
            }
          },
          series: donutData
        });
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
  }]);
  return MwChartDonut;
}();

exports.default = MwChartDonut;